import { axiosWithHeaders } from '@innovyze/lib_get_service';
import { apiConfig } from '../../../apis/config.api';
import retry from 'axios-retry';
import { AxiosResponse } from 'axios';
import { DSTreeObject } from '@innovyze/stylovyze';

const api = axiosWithHeaders({
  service: 'workgroupDatastore',
  config: apiConfig,
  axiosCreateOpts: {
    timeout: 30_000,
  },
});

retry(api, {
  retries: 3,
  retryDelay: retry.exponentialDelay,
  retryCondition: retry.isNetworkOrIdempotentRequestError,
});

export function retrieve(
  signal: AbortSignal,
  dbid: string,
  analysisGroupId: string
): Promise<AxiosResponse<{ treeobjects: DSTreeObject[] }>> {
  return api.get(
    `/v2/databases/${dbid}/treeobjects/${analysisGroupId}/children`,
    {
      signal,
    }
  );
}
